import React from 'react'
import { connect } from 'react-redux'

import StringFormat from 'utils/StringFormat'

import Button from 'components/Button'

import { TagPushCart } from 'analytics/cart'

import { setQntProduct, setValueProduct } from 'store/actions/cart'
import { bankNameSelector } from 'store/selectors/bank'

import CartListItem from './CartListItem'

import { Actions } from './CartMenu.style'
import { List, Title } from './CartList.style'

const CartList = ({ cart, openModal, bankName, open, validate = () => {} }) => {
    const addMoreProducts = () => {
        TagPushCart.interactionAddMoreProducts(bankName)
        open()
    }

    return (
        <>
            <Title>MINHA CESTA</Title>
            <List>
                {cart.map((product, index) => (
                    <CartListItem
                        key={product.id}
                        index={index}
                        product={product}
                        openModal={openModal}
                    />
                ))}
            </List>
            <Actions>
                <Button
                    id="cartSeeProposal"
                    type="button"
                    kind="basic width-90"
                    onClick={validate}
                >
                    Ver proposta
                </Button>
                <Button
                    id="cartAddMoreProducts"
                    type="button"
                    kind="link width-80"
                    onClick={addMoreProducts}
                >
                    Adicionar ou Editar Produtos
                </Button>
            </Actions>
        </>
    )
}

const mapStateToProps = (state) => ({
    bankName: bankNameSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    setValueProduct: (index, value) => {
        const v1 = StringFormat.convertToMonetary(value, 6)
        const newValue = StringFormat.removeMaskCurrency(v1)
        dispatch(setValueProduct(index, newValue))
    },
    setQntProduct: (index, value) => {
        if (+value >= 0 && +value <= 999999) {
            dispatch(setQntProduct(index, value))
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(CartList)
